(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.cart-drawer__panel');
  var items = drawer.querySelector('[data-cart-drawer-items]');
  var subtotal = drawer.querySelector('[data-cart-subtotal]');
  var errorNode = drawer.querySelector('[data-cart-error]');
  var countNodes = document.querySelectorAll('[data-cart-count], .cart-count');
  var currency = document.documentElement.getAttribute('data-shop-currency') || 'USD';
  var lastFocused = null;

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }
  function imageUrl(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=192';
  }
  function setCount(count) {
    countNodes.forEach(function (node) { node.textContent = count; });
  }
  function setError(message) {
    if (errorNode) errorNode.textContent = message || '';
  }
  function setBusy(busy) {
    drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
  function focusableElements() {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
  }
  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    window.setTimeout(function () {
      var close = drawer.querySelector('.cart-drawer__close');
      if (close) close.focus(); else if (panel) panel.focus();
    }, 40);
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    setError('');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }
  function emptyMarkup() {
    return '<div class="cart-drawer__empty"><div><svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M7 10h18l-1.5 17h-15L7 10Z"></path><path d="M12 11V8a4 4 0 0 1 8 0v3"></path></svg><strong>Your cart is empty.</strong><span>Add something useful and it will appear here.</span></div></div>';
  }
  function render(cart) {
    setCount(cart.item_count);
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (!cart.items.length) {
      items.innerHTML = emptyMarkup();
      return;
    }
    items.innerHTML = cart.items.map(function (item) {
      var image = item.image ? '<img src="' + escapeHtml(imageUrl(item.image)) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      return '<article class="cart-drawer__item">' + image + '<div class="cart-drawer__item-info"><a class="cart-drawer__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant + '<p class="cart-drawer__price">' + money(item.final_price) + '</p><div class="cart-drawer__quantity-row"><div class="cart-drawer__quantity" aria-label="Quantity"><button type="button" data-cart-change="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-cart-change="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div><button type="button" class="cart-drawer__remove" data-cart-change="' + escapeHtml(item.key) + '" data-quantity="0">Remove</button></div></div></article>';
    }).join('');
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    });
  }
  function refreshCart() {
    setBusy(true);
    setError('');
    return getCart().then(render).catch(function (error) {
      setError('Unable to load your cart. Please try again.');
      throw error;
    }).finally(function () { setBusy(false); });
  }
  function changeLine(key, quantity) {
    setBusy(true);
    setError('');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update cart');
      return response.json();
    }).then(render).catch(function (error) {
      setError('We could not update that item. Please try again.');
      throw error;
    }).finally(function () { setBusy(false); });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    var message = form.querySelector('#cartMessage');
    setBusy(true);
    setError('');
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add item');
        return response.json();
      })
      .then(function () {
        if (message) message.textContent = 'Added to cart.';
        return getCart();
      })
      .then(function (cart) { render(cart); openDrawer(); })
      .catch(function () {
        if (message) message.textContent = 'Unable to add this item. Please try again.';
        setError('Unable to add this item. Please try again.');
      })
      .finally(function () { setBusy(false); });
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-drawer-open]');
    var closer = event.target.closest('[data-cart-drawer-close]');
    var change = event.target.closest('[data-cart-change]');
    if (opener) {
      event.preventDefault();
      lastFocused = opener;
      refreshCart().then(openDrawer).catch(function () {});
    }
    if (closer) { event.preventDefault(); closeDrawer(); }
    if (change) {
      event.preventDefault();
      changeLine(change.getAttribute('data-cart-change'), Number(change.getAttribute('data-quantity'))).catch(function () {});
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    var nodes = focusableElements();
    if (!nodes.length) { event.preventDefault(); if (panel) panel.focus(); return; }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
}());
